<div class="form-group primary" style="padding-top: 10px;">

  <label>Lead reviewer</label>

  @if (row.registrantType===RegistrantType.Pharmacist) {
    <mat-select class="form-control"
      (ngModelChange)="validateReviewerSelection(row, $event, 'lead')" [(ngModel)]="editing.lead"
      placeholder="Select a reviewer...">
      @for (reviewer of pharmReviewersSorted; track reviewer; let i = $index) {
        <mat-option [value]="reviewer.userId">
          <ng-container *ngTemplateOutlet="reviewerListItem; context:{$implicit: reviewer}"></ng-container>
        </mat-option>
      }
    </mat-select>
  }
  @if (row.registrantType===RegistrantType.PharmacyTechnician) {
    <mat-select class="form-control"
      (ngModelChange)="validateReviewerSelection(row, $event, 'lead')" [(ngModel)]="editing.lead"
      placeholder="Select a reviewer...">
      @for (reviewer of techReviewersSorted; track reviewer; let i = $index) {
        <mat-option [value]="reviewer.userId">
          <ng-container *ngTemplateOutlet="reviewerListItem; context:{$implicit: reviewer}"></ng-container>
        </mat-option>
      }
    </mat-select>
  }
</div>

<div class="form-group secondary">

  <label>Secondary reviewer</label>

  @if (row.registrantType===RegistrantType.Pharmacist) {
    <mat-select class="form-control"
      (ngModelChange)="validateReviewerSelection(row, $event, 'secondary')" [(ngModel)]="editing.secondary"
      placeholder="Select a reviewer...">
      @for (reviewer of pharmReviewersSorted; track reviewer; let i = $index) {
        <mat-option [value]="reviewer.userId">
          <ng-container *ngTemplateOutlet="reviewerListItem; context:{$implicit: reviewer}"></ng-container>
        </mat-option>
      }
    </mat-select>
  }
  @if (row.registrantType===RegistrantType.PharmacyTechnician) {
    <mat-select class="form-control"
      (ngModelChange)="validateReviewerSelection(row, $event, 'secondary')" [(ngModel)]="editing.secondary"
      placeholder="Select a reviewer...">
      @for (reviewer of techReviewersSorted; track reviewer; let i = $index) {
        <mat-option [value]="reviewer.userId">
          <ng-container *ngTemplateOutlet="reviewerListItem; context:{$implicit: reviewer}"></ng-container>
        </mat-option>
      }
    </mat-select>
  }

  <ng-template #reviewerListItem let-reviewer>
    <div class="reviewer-list-item">
      <div class="reviewer-name">{{ reviewer.name }} - </div>
      <div class="reviewer-type">{{ reviewer.type }}</div>
    </div>
  </ng-template>

</div>

<app-collapsible [trigger]="!editing.isValid">
  <div class="error"><i class="fa fa-warning"></i> {{editing.validationMessage}}</div>
</app-collapsible>

<button [disabled]="!editing.isValid || !willChangeReviewers || changingReviewers" class="btn  btn-block btn-primary"
  (click)="changeReviewers()">
  @if (!changingReviewers) {
    <span>Change reviewers</span>
  }
  @if (changingReviewers) {
    <span>Changing reviewers...</span>
  }
</button>